<template>
  <div id="updateCalendar" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo catalogoTitle"
        >ACTUALIZAR CALENDARIO</v-row
      >
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2 mt-n3">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris mt-n3">
          <select
            name="empresa"
            id="empresa"
            v-model="dataCalendar.empresaId"
            disabled
          >
            <option disabled value="0" selected>Selecciona Empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="calendar">Nombre</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            type="text"
            name="calendar"
            id="calendar"
            class="inputs px-2"
            autocomplete="false"
            placeholder="Calendario..."
            style="width: 205px !important"
            v-model="dataCalendar.nombre"
            maxlength="20"
            @keypress="alfaNumerico($event)"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="description">Descripción</label>
        </v-col>
        <v-col cols="12" sm="4" class="pa-2 com">
          <textarea
            id="description"
            placeholder="Editor de texto..."
            v-model="dataCalendar.descripcion"
            @keypress="alfaNumerico($event)"
            class="inputs mx-2 selectGris"
          ></textarea>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Lunes</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="lunes"
            id="lunes"
            v-model="dataCalendar.lunesCatalogoId"
          >
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>

        <v-col cols="12" sm="8" class="py-2">Martes</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="martes"
            id="martes"
            v-model="dataCalendar.martesCatalogoId"
          >
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select> </v-col
        ><v-col cols="12" sm="8" class="py-2">Miercoles</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="miercoles"
            id="miercoles"
            v-model="dataCalendar.miercolesCatalogoId"
          >
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Jueves</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="miercoles"
            id="miercoles"
            v-model="dataCalendar.juevesCatalogoId"
          >
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Viernes</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="miercoles"
            id="miercoles"
            v-model="dataCalendar.viernesCatalogoId"
          >
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Sábado</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="miercoles"
            id="miercoles"
            v-model="dataCalendar.sabadoCatalogoId"
          >
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Domingo</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="miercoles"
            id="miercoles"
            v-model="dataCalendar.domingoCatalogoId"
          >
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>

        <v-col cols="12" sm="8" class="py-2">Aplica a</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="aplica"
            id="aplica"
            v-model="aplica"
            @change="condicion()"
          >
            <option disabled selected value="0">
              Seleccione lugar de aplicación
            </option>
            <option value="1">Áreas</option>
            <option value="2">Sucursales</option>
          </select>
        </v-col>
        <!--areas-->
        <v-col cols="12" sm="8" class="py-2" v-if="areaTrue"
          >Cátalogo de áreas</v-col
        >
        <v-col cols="12" sm="4" class="py-2" v-if="areaTrue">
          <multiselect
            v-model="dataCalendar.calendarioAreas"
            trackBy="id"
            label="nombreArea"
            @input="areasAuxiliares"
            placeholder="Seleccione área(s)"
            tag-placeholder="Agregar área"
            selectLabel="Enter para agregar"
            deselectLabel="Enter para eliminar"
            selectedLabel="Seleccionado"
            :multiple="true"
            :options="areas"
            class=""
            style="
              width: 210px !important;
              background: rgb(199, 195, 199) !important;
            "
          >
            <span slot="noResult"
              >No se encontraron elementos con la búsqueda</span
            >
            <span slot="noOptions">No existen elementos</span>
          </multiselect>
        </v-col>
        <!--sucursales-->
        <v-col cols="12" sm="8" class="py-2" v-if="branchTrue"
          >Cátalogo de sucursales</v-col
        >
        <v-col cols="12" sm="4" class="py-2" v-if="branchTrue">
          <multiselect
            v-model="dataCalendar.calendarioSucursales"
            track-by="id"
            @input="sucursalAuxiliar"
            label="nombreSucursal"
            placeholder="Seleccione sucursal(es)"
            tag-placeholder="Agregar sucursal"
            selectLabel="Enter para agregar"
            deselectLabel="Enter para eliminar"
            selectedLabel="Seleccionado"
            :multiple="true"
            :options="branches"
            class="inputs"
            style="width: 170px !important"
          >
            <span slot="noResult"
              >No se encontraron elementos con la búsqueda</span
            >
            <span slot="noOptions">No existen elementos</span>
          </multiselect>
        </v-col>
        <v-col>
          <div class="form-group text-center terminos mt-1">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="400">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Nofificaciones</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="center">{{ respuesta }}</h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de modificar el Calendario?
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="cancelar()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Calendario</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-sm-center text-md-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      area: "",
      nombreCorto: "",
      level: 0,
      show: false,
      search: "",
      dialog: false,
      errors: [],
      respuesta: "",
      advice: false,
      error: false,
      confirmation: false,
      dataCalendar: [
        {
          enterprise: 0,
          calendar: "Produccion",
          lunes: 2,
          martes: 1,
          miercoles: 2,
          jueves: 2,
          viernes: 1,
          sabado: 3,
          domingo: 3,
          description: "Calendario de producccion",
        },
      ],
      enterprises: [],
      enterprise: 0,
      areaTrue: false,
      branchTrue: false,
      areas: [],
      areasAux: [],
      branches: [],
      sucursales: [],
      aplica: 0,
      sucursalesSeleccionadas: [],
      areasSeleccionadas: [],
      tiempos: [
        { id: 1, name: "Tiempo completo" },
        { id: 3, name: "Medio Tiempo" },
        { id: 2, name: "Descanso" },
      ],
    };
  },
  methods: {
    areasAuxiliares() {
      var auxAreas = [];
      this.areasAux = [];
      this.dataCalendar.calendarioAreas.forEach((area) =>
        this.areasAux.push(area.id)
      );
      this.areasAux.forEach((area) => {
        if (area != undefined) {
          auxAreas.push(area);
        }
      });
      //console.log("AuxInternoArea", auxAreas);
      this.areasAux = auxAreas;
      //areasAux es el que se pasa a la api
      //console.log("Aux que se envía", this.areasAux);
    } /*
    areasAuxiliares() {
      this.areasAux = [];
      this.dataCalendar.calendarioAreas.forEach((area) => this.areasAux.push(area.id));
      //areasAux es el que se pasa a la api
      console.log(this.areasAux);
    },*/,
    sucursalAuxiliar() {
      var auxSucursales = [];
      this.sucursales = [];
      this.dataCalendar.calendarioSucursales.forEach((suc) =>
        this.sucursales.push(suc.id)
      );
      this.sucursales.forEach((id) => {
        if (id != undefined) {
          auxSucursales.push(id);
        }
      });
      //console.log("AuxSucursalInterno", auxSucursales);
      this.sucursales = auxSucursales;
      //sucursales es el que se pasa a la api
      //console.log("array que se envia", this.sucursales);
    },
    /*sucursalAuxiliar() {
      this.sucursales = [];
      this.dataCalendar.calendarioSucursales.forEach((suc) =>
        this.sucursales.push(suc.id)
      );
      //sucursales es el que se pasa a la api
      console.log(this.sucursales);
    },*/
    guardar() {
      this.advice = false;
      /*console.log("llegue a modificar");
      console.log("areasaux",this.areasAux);
      console.log("sucursales",this.sucursales);*/
      this.show = true;
      axios
        .put(Server + "/calendarios/" + this.dataCalendar.id, {
          Id: this.dataCalendar.id,
          EmpresaId: this.dataCalendar.empresaId,
          Nombre: this.dataCalendar.nombre,
          Descripcion: this.dataCalendar.descripcion,
          LunesCatalogoId: parseInt(this.dataCalendar.lunesCatalogoId),
          MartesCatalogoId: parseInt(this.dataCalendar.martesCatalogoId),
          MiercolesCatalogoId: parseInt(this.dataCalendar.miercolesCatalogoId),
          ViernesCatalogoId: parseInt(this.dataCalendar.viernesCatalogoId),
          JuevesCatalogoId: parseInt(this.dataCalendar.juevesCatalogoId),
          SabadoCatalogoId: parseInt(this.dataCalendar.sabadoCatalogoId),
          DomingoCatalogoId: parseInt(this.dataCalendar.domingoCatalogoId),
          Sucursales: this.sucursales,
          Areas: this.areasAux,
        })
        .then((response) => {
          localStorage.idCalendar = "";
          this.show = false;
          this.respuesta = "El calendario fue modificado con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          localStorage.idCalendar = "";
          this.respuesta = "El calendario no fue modificado.";
          this.confirmation = true;
        });
    },
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]+$"); // Letras,espacio y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    regresar() {
      this.$router.push("/calendar");
    },
    validacion: function () {
      this.errors = [];
      if (
        this.dataCalendar.empresaId == " " ||
        this.dataCalendar.enterprise == 0
      ) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.dataCalendar.nombre == " " || this.dataCalendar.calendar == "") {
        this.errors.push("Se debe especificar nombre del calendario.");
      }
      if (
        this.dataCalendar.descripcion == " " ||
        this.dataCalendar.description == ""
      ) {
        this.errors.push("Se debe especificar la descripcion del calendario.");
      }
      if (this.dataCalendar.lunesCatalogoId == 0) {
        this.errors.push("Se debe seleccionar el horario el día lunes.");
      }
      if (this.dataCalendar.martesCatalogoId == 0) {
        this.errors.push("Se debe seleccionar el horario el día martes.");
      }
      if (this.dataCalendar.miercolesCatalogoId == 0) {
        this.errors.push("Se debe seleccionar el horario el día miercoles.");
      }
      if (this.dataCalendar.juevesCatalogoId == 0) {
        this.errors.push("Se debe seleccionar el horario el día jueves.");
      }
      if (this.dataCalendar.viernesCatalogoId == 0) {
        this.errors.push("Se debe seleccionar el horario el día viernes.");
      }
      if (this.dataCalendar.sabadoCatalogoId == 0) {
        this.errors.push("Se debe seleccionar el horario el día sabado.");
      }
      if (this.dataCalendar.domingoCatalogoId == 0) {
        this.errors.push("Se debe seleccionar el horario el día domingo.");
      }
      if (this.aplica == 1 && this.dataCalendar.calendarioAreas.length == 0) {
        this.errors.push("Se debe especificar el(las) área(s).");
      }
      if (
        this.aplica == 2 &&
        this.dataCalendar.calendarioSucursales.length == 0
      ) {
        this.errors.push("Se debe especificar la(s) sucursal(es).");
      }
      if (this.errors.length == 0) {
        return (this.advice = true);
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    aux() {
      this.confirmation = false;
      localStorage.idCalendar = "";
      this.$router.push("/calendar");
    },
    cancelar() {
      localStorage.idCalendar = "";
      this.advice = false;
      this.$router.push("/calendar");
    },
    recuperar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
      this.show = true;
      axios
        .get(Server + "/calendarios/" + localStorage.idCalendar)
        .then((response) => {
          this.show = false;
          this.dataCalendar = response.data;
          if (this.dataCalendar.calendarioSucursales.length > 0) {
            this.dataCalendar.calendarioSucursales.forEach((element, index) => {
              this.sucursales.push(element.id);
            });
            this.aplica = 2;
            this.areaTrue = false;
            this.branchTrue = true;
            this.areasAux = [];
          } else if (this.dataCalendar.calendarioAreas.length > 0) {
            this.dataCalendar.calendarioAreas.forEach((element, index) => {
              this.areasAux.push(element.id);
            });
            this.aplica = 1;
            this.sucursales = [];
            this.branchTrue = false;
            this.areaTrue = true;
          }
          this.obtenerAreasSucursales();
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    obtenerAreasSucursales() {
      this.branches = [];
      this.show = true;
      axios
        .get(Server + "/sucursales/por-empresa/" + this.dataCalendar.empresaId)
        .then((response) => {
          this.show = false;
          //console.log("resultado de todas las areas");
          response.data.forEach((element) => {
            if (
              element.calendarioId == null ||
              element.calendarioId == localStorage.idCalendar
            ) {
              this.branches.push(element);
            }
          });
          //console.log(this.branches);
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
      this.areas = [];
      this.show = true;
      axios
        .get(Server + "/areas")
        .then((response) => {
          this.show = false;
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (
              value.empresaId == this.dataCalendar.empresaId &&
              (value.calendarioId == null ||
                value.calendarioId == localStorage.idCalendar)
            ) {
              this.areas.push({
                id: value.id,
                nombreArea: value.nombreArea,
                nombreCorto: value.nombreAreaCorto,
                empresa: value.empresaId,
                nombreEmpresa: value.empresa,
                nivelJerarquico: value.nivelJerarquico,
              });
            }
          });
          //console.log(this.areas);
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
    },
    condicion() {
      if (this.aplica == "1") {
        this.dataCalendar.calendarioAreas = [];
        this.sucursales = [];
        this.branchTrue = false;
        this.areaTrue = true;
      }
      if (this.aplica == "2") {
        this.dataCalendar.calendarioSucursales = [];
        this.areasAux = [];
        this.areaTrue = false;
        this.branchTrue = true;
      }
    },
  },
  created() {
    this.recuperar();
  },
};
</script>
<style>
ul {
  list-style-type: none !important;
  display: inline-block;
}
li.multiselect_element {
  list-style-type: none !important;
}
ul.multiselect__element,
ol.multiselect__option.multiselect__option--highlight {
  text-decoration: none;
}
.v-application ol,
.v-application ul {
  padding-left: 0px !important;
  text-decoration: none !important;
}
.multiselect__option.multiselect__option--highlight {
  background: rgb(250, 181, 52) !important;
}
.multiselect__tag {
  background: rgba(253, 175, 29, 0.856) !important;
}
li.multiselect__element::marker {
  text-decoration: none !important;
}
.multiselect__option--highlight:after {
  background: rgba(236, 154, 0, 0.856) !important;
}
</style>